/**
 * Keeps the page behind a dialog still on touch devices.
 * The app scrolls inside mat-sidenav-content, which the dialog's own scroll lock does not cover,
 * and dragging the backdrop otherwise triggers the browser's overscroll stretch on the whole page.
 * Returns a function that restores the earlier inline values.
 */
export function lockPageScroll(doc: Document): () => void {
  const containers = Array.from(doc.querySelectorAll<HTMLElement>('mat-sidenav-content'))
    .filter(element => !element.closest('.cdk-overlay-container'));
  const roots = [doc.documentElement, doc.body];
  const previousOverflow = containers.map(element => element.style.overflow);
  const previousOverscroll = roots.map(element => element.style.overscrollBehavior);
  containers.forEach(element => element.style.overflow = 'hidden');
  roots.forEach(element => element.style.overscrollBehavior = 'none');
  return () => {
    containers.forEach((element, index) => element.style.overflow = previousOverflow[index]);
    roots.forEach((element, index) => element.style.overscrollBehavior = previousOverscroll[index]);
  };
}
